import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BackButtonPage } from "components/__new/common/BackButton";
import { Input, ButtonLoader, CheckboxGroupSelector, SelectInput } from "components/__new/common/form";
import iconPreview from "assets/images/icons/icon-preview.svg";
import { Link } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import Maybe from "components/__new/common/Maybe";
import useLoginInfo from "hooks/useLoginInfo";
import useBillPaymentUserId from "hooks/useBillPaymentUserId";
import useForceUpdate from "hooks/useForceUpdate";
import useWallet from "hooks/useWallet";
import { toast } from "react-toastify";
import CurrencyFormat from "utils/currencyFormat";
import iconDocCsv from "assets/images/icons/icon-doc-csv.svg";
// import iconDownload from "assets/images/icons/project-icons/download.svg";
// import { jsonToFormData } from "utils/jsonToFormData";
import PageContent from "components/__new/common/PageContent";
import PinModal from "components/__new/common/PinModal";
import maskEmailAddress from "utils/maskData";
import ModalAlert from "components/__new/common/ModalAlert";
import sittingOnBench from "assets/images/bgs/SittingOnBench.png";
import SearchableBillPaymentProviders from "components/__new/billPayment/Providers";
import { FileUploader } from "react-drag-drop-files";
import getFileSize from "utils/getFileSize";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FileUploadUI from "components/__new/common/form/FileUploadUI";
import validate from "utils/validate";
import SearchableEmployees from "components/__new/common/dropdown-search/Employees";
import * as walletAction from "store/entities/wallet/action";
import * as billPaymentAction from "store/entities/billPayment/action";
import useEmployerProducts from "hooks/useEmployerProducts";
import useAccessPinStatus from "hooks/useAccessPinStatus";


export const BuyPower = () => {
    const dispatch = useDispatch();
    const {userInfo, updateIsAccessPinSet} = useLoginInfo();
    const {isOnDemandUser} = useEmployerProducts()
    const {billPaymentUserId} = useBillPaymentUserId();
    const forceUpdate = useForceUpdate();
    const { walletLoading, createWallet } = useWallet();
    const {getAccessPinStatus} = useAccessPinStatus();
    const searchableBillPaymentProvidersRef = useRef();
    const searchableEmployeesRef = useRef();
    const { dashboardLoading, dashboard, otpGenerationLoading, otpGeneration, accessPinLoading, accessPin } = useSelector((s) => s.entities.wallet);    
    const { electricityValidationLoading, electricityValidation, electricityPurchaseLoading, electricityPurchase } = useSelector((s) => s.entities.billPayment);    
    

    const [transferType, setTransferType] = useState([
        { label: "For Individual", value: "single", selected: true },
        { label: "For Multiple", value: "multiple", selected: false },
    ])
    
    const [isOpenAccessPin, setIsOpenAccessPin] = useState(false);
    const [isOpenOtpNewPin, setIsOpenOtpNewPin] = useState(false);
    const [isOpenNewAccessPin, setIsOpenNewAccessPin] = useState(false);
    const [isOpenConfirmAccessPin, setIsOpenConfirmAccessPin] = useState(false);
    const [isOpenModalAlertTransferSuccess, setIsOpenModalAlertTransferSuccess] = useState(false);
    const [isOpenModalAlertNewPinSuccess, setIsOpenModalAlertNewPinSuccess] = useState(false);
    
    const [searchEmployeeList, setSearchEmployeeList] = useState(false);
    const defaultForm = {
        account: "",
        accountType: "",
        amount: "",
        phoneNumber: "",
        network: {},
        employee: {},
        name: "",
        address: "",
        isValidated: false,
    }
    const [form, setForm] = useState(defaultForm);
    const [forms, setForms] = useState([]);
    const [bulkUpload, setBulkUpload] = useState(null);
    const [pin, setPin] = useState({
        otp: "",
        accessPin: "",
        accessPinConfirm: "",
    })


    const updateTransferType = (type) => {
        const newTransferType = transferType.map((qa) => {
            if (qa.value === type){
                return {...qa, selected: true}
            }
            else{
                return {...qa, selected: false}
            }
        });
        setTransferType(newTransferType);
    }


    const getActiveTransferType = () => {
        const newTransferType = transferType.filter((type) => type.selected === true);
        return(newTransferType[0]?.value || "");
    }


    const verifyDetails = (account, accountType, network) => {
        const params = {
            account: account || form.account,
            accountType: accountType || form.accountType,
            service: network || form.network?.value,
            userId: userInfo.employer._id,
        }

        if (
            (params.account !== "" && params.account !== undefined) &&
            (params.accountType !== "" && params.accountType !== undefined) &&
            (params.service !== "" && params.service !== undefined)
        ){
            dispatch(billPaymentAction.electricityPurchaseValidation(params));
        }
        else{
            setForm((form) => {return({...form, name: "", address: "", isValidated: false})});
        }

    }


    const validateForm = () => {
        let noErrors = true;

        if (!form.network?.value){
            noErrors = false;
            toast.error("Please select a network");
        }
        
        if (form.account === "" || form.account <= 0 || isNaN(form.account) === true){
            noErrors = false;
            toast.error("Please enter the meter number");
        }
        
        if (form.accountType === ""){
            noErrors = false;
            toast.error("Please select the meter type");
        }
        
        if (form.amount === "" || form.amount <= 0 || isNaN(form.amount) === true){
            noErrors = false;
            toast.error("Please enter a valid amount");
        }

        if (form.phoneNumber === ""){
            noErrors = false;
            toast.error("Please enter the recipient phone number or select from the list of employees");
        }

        if (form.phoneNumber !== ""){
            const errors = validate({phoneNumber: form.phoneNumber});
            if (errors){
                noErrors = false;
                for (var x in errors) {
                    toast.error(errors[x]);
                }
            }
        }
        
        return noErrors;
    }


    const resetForm = () => {
        setForm(defaultForm);
        // setSearchEmployeeList(false);
        searchableBillPaymentProvidersRef.current?.clearSearchableBillPaymentProviders();
        searchableEmployeesRef.current?.clearSearchableEmployees();
        resetPins();
    }


    const resetPins = () => {
        setPin({ ...pin, otp: "", accessPin: "", accessPinConfirm: "" });
    }


    const removeForm = (index) => {
        const allForms = forms;
        allForms.splice(index, 1);
        setForms(allForms);
        forceUpdate();
    }


    const submitForm = async (e) => {
        e.preventDefault();

        if (getActiveTransferType() === "single"){
            if (validateForm()){
                initiateTransfer();
            }
        }
        else if (getActiveTransferType() === "multiple"){
            if (validateForm()){
                const allForms = forms;
                allForms.push(form);
                setForms(allForms);
                forceUpdate();
                resetForm();
            }
        }
        else if (getActiveTransferType() === "bulk-upload"){
            if (bulkUpload !== null && bulkUpload !== undefined){
                initiateTransfer();
            }
            else{
                toast.error("Please select a file to upload");
            }
        }
    }


    const submitMultipleTransfer = () => {
        if (forms.length > 0){
            initiateTransfer();
        }
        else{
            toast.error("Please add the transactions to process");
        }
    }


    const initiateTransfer =() => {
        resetPins();

        const hasAccessPin = getAccessPinStatus(dashboard);
        if (hasAccessPin === null || hasAccessPin === false){
            setIsOpenNewAccessPin(true);
        }
        else if (hasAccessPin === true){
            setIsOpenAccessPin(true);
        }
    }


    const generateClientReference = (phoneNumber) => {
        const date = Date.parse(new Date());
        const clientReference = userInfo?.employer?.firstName?.charAt(0) + userInfo?.employer?.lastName?.charAt(0) + date + phoneNumber;
        // console.log(clientReference);
        return (clientReference);
    }
    

    const processTransfer =() => {
        const defaultParams = {
            channel: "web",
            userId: billPaymentUserId,
            accessPin: pin.accessPin,
        }

        if (getActiveTransferType() === "single"){
            const params = {
                ...defaultParams,
                account: form.account,
                amount: parseInt(form.amount) * 100,
                phone: form.phoneNumber,
                service: form.network?.value,
                accountType: form.accountType,
                name: form.name,
                address: form.address,
                clientReference: generateClientReference(form.phoneNumber),
            }
            // console.log("params", params);
            dispatch(billPaymentAction.electricityPurchaseSingle(params));
        }
        else if (getActiveTransferType() === "multiple"){
            const params = {
                ...defaultParams,
                beneficiaries: forms.map((e) => {
                    return {
                        account: e.account,
                        phone: e.phoneNumber,
                        service: e.network?.value,
                        accountType: e.accountType,
                        amount: parseInt(e.amount) * 100,
                        name: e.name,
                        address: e.address,
                        clientReference: generateClientReference(e.phoneNumber),
                    }
                }),
            }
            // console.log("params", params);
            dispatch(billPaymentAction.electricityPurchaseMultiple(params));
        }
        else if (getActiveTransferType() === "bulk-upload"){
            // const params = {
            //     csv: bulkUpload,
            //     otp: pin.otp,
            // }
            alert("on hold");
            // console.log("params", params);
            // const paramsFormData = jsonToFormData(params);
            // dispatch(billPaymentAction.electricityPurchaseUpload(paramsFormData));
        }
    }


    useEffect(() => {
        // if (otpGeneration?.status === "success"){
        if (otpGeneration?.error === false){
            const hasAccessPin = getAccessPinStatus(dashboard);
            if (hasAccessPin === null || hasAccessPin === false){
                setIsOpenConfirmAccessPin(false);
                setIsOpenOtpNewPin(true);
            }
            dispatch(walletAction.generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])


    useEffect(() => {
        if (accessPin?.status === "success"){
            setIsOpenOtpNewPin(false);
            setIsOpenModalAlertNewPinSuccess(true);
            resetPins();
            dispatch(walletAction.createAccessPinReset());
            dispatch(walletAction.getDashboard(userInfo));
            // updateIsAccessPinSet(true);
        }
        // eslint-disable-next-line
    }, [accessPin])


    useEffect(() => {
        if (electricityValidationLoading === false){
            if (electricityValidation?.status === "success"){
                const name = electricityValidation?.response?.name;
                const address = (electricityValidation?.response?.address ?? "" + electricityValidation?.response?.district ?? "") || "";
                setForm({...form, name: name || "", address: address || "", isValidated: true});
            }
            else{
                setForm({...form, name: "", address: "", isValidated: false});
            }
        }
        else{
            setForm({...form, name: "Loading...", address: "Loading...", isValidated: false});
        }
        // eslint-disable-next-line
    }, [electricityValidationLoading, electricityValidation])


    useEffect(() => {
        if (electricityPurchase?.status === "success" || electricityPurchase?.status === "successful"){
            setIsOpenAccessPin(false);
            setIsOpenModalAlertTransferSuccess(true);
            resetForm();
            setForms([]);
            setBulkUpload(null);
            dispatch(billPaymentAction.electricityPurchaseReset());
        }
        else if (electricityPurchase?.status === "failed"){
            // setIsOpenAccessPin(false);
            dispatch(billPaymentAction.electricityPurchaseReset());
        }
        else if (electricityPurchase?.status === "pending"){
            toast.error(electricityPurchase?.message);
            dispatch(billPaymentAction.electricityPurchaseReset());
        }
        // eslint-disable-next-line
    }, [electricityPurchase])


    return (
        <div>

            <DynamicHeadTag
                headerText="Buy Power - Electricity Bills"
            />


            <Maybe condition={dashboardLoading === true}>
                <PageContent loading={dashboardLoading} />
            </Maybe>


            <Maybe condition={dashboardLoading === false && dashboard?.status === "success"}>
                <>

                    <PinModal
                        target="Access Pin"
                        title="Validate Purchase"
                        description="Enter Access Pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={processTransfer}
                        loading={electricityPurchaseLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        showForgotPin={true}
                    />


                    <ModalAlert
                        successText="Transaction successful"
                        dismissText="Perform another transaction"
                        isOpenModalAlert={isOpenModalAlertTransferSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertTransferSuccess}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Create Access Pin"
                        description="Set new access pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={() => {
                            setIsOpenNewAccessPin(false);
                            setIsOpenConfirmAccessPin(true);
                        }}
                        loading={false}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenNewAccessPin}
                        setIsOpenPin={setIsOpenNewAccessPin}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Confirm Access Pin"
                        description="Please re-enter your access pin"
                        pin={(e) => setPin({...pin, accessPinConfirm: e})}
                        submit={() => {
                            if (pin.accessPin === pin.accessPinConfirm){
                                if (userInfo.employer.userType === "employer"){
                                    dispatch(walletAction.generateOtp(userInfo.token, "access-pin"));
                                }
                                else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                    dispatch(walletAction.generateOtpEmployerAdmin(null, 'access-pin'));
                                }
                            }
                            else{
                                toast.error("Your access pin does not match");
                            }
                        }}
                        loading={otpGenerationLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenConfirmAccessPin}
                        setIsOpenPin={setIsOpenConfirmAccessPin}
                    />


                    <PinModal
                        target="OTP"
                        title="Enter OTP"
                        description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email) + ", to create your new access pin"}
                        pin={(e) => setPin({...pin, otp: e})}
                        submit={() => {
                            const params = {otp: parseInt(pin.otp), accessPin: pin.accessPin}
                            if (userInfo.employer.userType === "employer"){
                                dispatch(walletAction.createAccessPin(userInfo.token, params));
                            }
                            else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                dispatch(walletAction.createAccessPinEmployerAdmin(params));
                            }
                        }}
                        loading={accessPinLoading}
                        modalLoading={otpGenerationLoading}
                        isOpenPin={isOpenOtpNewPin}
                        setIsOpenPin={setIsOpenOtpNewPin}
                    />


                    <ModalAlert
                        successText="Access Pin created successfully"
                        dismissText="Back to Power purchase"
                        isOpenModalAlert={isOpenModalAlertNewPinSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertNewPinSuccess}
                        submit={() => {
                            setIsOpenModalAlertNewPinSuccess(false);
                            setIsOpenAccessPin(true);
                        }}
                    />


                    <div className="lg:flex">
                        <div className="w-full lg:w-1/2">
                            <div className="page-title flex">
                                <BackButtonPage link="/payments/bills" />
                                <div>
                                    Buy Power
                                    <div className="text-sm font-normal">
                                        Pay your electricity bills with ease
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
                    </div>


                    <form onSubmit={submitForm} className="mt-6 box">
                        <div className="xl:flex xl:space-x-8 xl:justify-between">

                            <div>
                                <div>
                                    <CheckboxGroupSelector selectOptions={transferType} onValueChange={(e) => updateTransferType(e)} />

                                    <div className="mt-6">
                                        <Maybe condition={getActiveTransferType() !== "bulk-upload"}>

                                            <div className="max-w-xs">
                                                <div className="mt-6">
                                                    <SearchableBillPaymentProviders
                                                        type="electricity"
                                                        label="Select Service"
                                                        tag="services"
                                                        ref={searchableBillPaymentProvidersRef}
                                                        onValueChange={(e) => {setForm({...form, network: e}); verifyDetails(undefined, undefined, e.value)}}
                                                    />
                                                </div>

                                                <div className="mt-6">
                                                    <Input type="text" label="Enter Meter Number" required={true} placeholder="Eg: 12345678901" value={form.account} onChange={(e) => setForm({...form, account: e.target.value})} onBlur={(e) => verifyDetails(e.target.value, undefined, undefined)} />
                                                </div>

                                                <div className="mt-6">
                                                    <SelectInput label="Select Meter Type" required={true} value={form.accountType} onChange={(e) => {setForm({...form, accountType: e.target.value}); verifyDetails(undefined, e.target.value, undefined)}}>
                                                        <option value="" disabled>Select</option>
                                                        <option value="prepaid">Prepaid</option>
                                                        <option value="postpaid">Postpaid</option>
                                                    </SelectInput>
                                                </div>

                                                <div className="mt-6">
                                                    <Input type="text" label="Enter Amount" required={true} placeholder="Eg: 5000" value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})} />
                                                </div>

                                                <div className="mt-6">
                                                    <Input type="tel" label="Enter Phone Number" required={true} placeholder="Eg: 080XXXXXXXX" value={form.phoneNumber} onChange={(e) => setForm({...form, phoneNumber: e.target.value})} readonly={searchEmployeeList} />
                                                </div>

                                                <div className="mt-6">
                                                    <Maybe condition={searchEmployeeList === false}>
                                                        <div onClick={() => isOnDemandUser && setSearchEmployeeList(true)} className={`w-max ${isOnDemandUser ? "text-ep-primary cursor-pointer" : "text-gray-400 cursor-not-allowed"}`}>
                                                            * <span className={`border-b ${isOnDemandUser ? "border-ep-primary" : "border-gray-400"}`}>Search Employee List</span>
                                                        </div>
                                                    </Maybe>

                                                    <Maybe condition={searchEmployeeList === true}>
                                                        <div onClick={() => {setSearchEmployeeList(false); setForm({...form, employee: {}})}} className="w-max text-ep-primary cursor-pointer">
                                                            * <span className="border-b border-ep-primary">Edit phone number</span>
                                                        </div>
                                                    </Maybe>
                                                </div>

                                                <Maybe condition={searchEmployeeList === true}>
                                                    <div className="mt-6">
                                                        <SearchableEmployees
                                                            ref={searchableEmployeesRef}
                                                            label="Choose from employee list"
                                                            onValueChange={(e) => setForm({...form, employee: e, phoneNumber: e?.phoneNumber})}
                                                        />
                                                    </div>
                                                </Maybe>

                                                <div className="mt-6">
                                                    <Input type="text" label="Customer Name" placeholder="" value={form.name} readonly={true} />
                                                </div>

                                                <div className="mt-6">
                                                    <Input type="text" label="Customer Address" placeholder="" value={form.address} readonly={true} />
                                                </div>

                                            </div>
                                        </Maybe>

                                        <Maybe condition={getActiveTransferType() === "bulk-upload"}>
                                            <div className="p-6 bg-[#F5F5F5] border border-dashed border-gray-300 rounded-2xl">
                                                <div className="h-60 border border-dashed border-gray-300 rounded-2xl overflow-hidden">

                                                    <Maybe condition={bulkUpload === null}>
                                                        <FileUploader handleChange={(e) => setBulkUpload(e)} name="csvupload" multiple={false} types={["csv"]} onTypeError={(err) => toast.error(err)} onSizeError={(err) => toast.error(err)}>
                                                            <FileUploadUI type="csv" />
                                                        </FileUploader>
                                                    </Maybe>

                                                    <Maybe condition={bulkUpload !== null}>
                                                        <div className="w-full h-full p-6 bg-[#FBFCFF] flex items-center justify-center">
                                                            <div>
                                                                <div className="h-20 flex">
                                                                    <img src={iconDocCsv} alt="file upload" className="object-contain mx-auto" />
                                                                </div>
                                                                <div className="mt-4 flex space-x-4 justify-between items-center">
                                                                    <div>
                                                                        <div className="flex space-x-4">
                                                                            <div className="max-w-sm ellipsis">{bulkUpload?.name}</div>
                                                                            <div>•</div>
                                                                            <div>{getFileSize(bulkUpload?.size)}</div>
                                                                        </div>
                                                                        <div className="w-full h-1 mt-1 bg-[#10B759] rounded-full"></div>
                                                                    </div>
                                                                    <div>
                                                                        <FontAwesomeIcon icon="times-circle" className="cursor-pointer hover:text-red-500" onClick={() => setBulkUpload(null)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Maybe>

                                                </div>

                                                <Maybe condition={bulkUpload === null}>
                                                    <div className="flex justify-end">
                                                        {/* 
                                                        <a href="#" target="_blank" rel="noreferrer" download className="w-max mt-4 flex items-center text-ep-primary text-sm hover:underline cursor-pointer">
                                                            <img src={iconDownload} alt="download template" className="mr-1" />
                                                            Download sample file
                                                        </a>
                                                         */}
                                                    </div>
                                                </Maybe>

                                            </div>
                                        </Maybe>
                                    </div>
                                </div>

                                <div className="mt-10 hidden xl:flex space-x-4">
                                    <SubmitButtons
                                        form={form}
                                        type={getActiveTransferType()}
                                        submitMultipleTransfer={submitMultipleTransfer}
                                        bulkUpload={bulkUpload}
                                        bulkUploadCancel={() => setBulkUpload(null)}
                                    />
                                </div>
                            </div>


                            <Maybe condition={getActiveTransferType() !== "bulk-upload"}>
                                <div className="xl:min-w-[400px]">
                                    <div className={"mt-10 xl:mt-0 h-full box bg-gray-100 border-none " + (getActiveTransferType() === "multiple" && "max-h-[440px] xl:max-h-[800px] overflow-auto")}>
                                        <div className="pb-3 font-semibold flex border-b border-dashed border-gray-400">
                                            Preview
                                            <img src={iconPreview} alt="filter" className="h-3.5 ml-2 my-auto" />
                                        </div>
                                        <div className="mt-6">
                                            <Maybe condition={getActiveTransferType() === "single"}>
                                                <TransactionInfo data={[form]}/>
                                            </Maybe>
                                            <Maybe condition={getActiveTransferType() === "multiple"}>
                                                <TransactionInfo
                                                    type={getActiveTransferType()}
                                                    data={forms}
                                                    removeForm={(index) => removeForm(index)}
                                                />
                                            </Maybe>
                                        </div>
                                    </div>
                                </div>
                            </Maybe>


                            <div className="mt-10 flex xl:hidden space-x-4">
                                <SubmitButtons
                                    form={form}
                                    type={getActiveTransferType()}
                                    submitMultipleTransfer={submitMultipleTransfer}
                                    bulkUpload={bulkUpload}
                                    bulkUploadCancel={() => setBulkUpload(null)}
                                />
                            </div>


                        </div>
                    </form>

                </>
            </Maybe>


            <Maybe condition={dashboardLoading === false && (dashboard?.status === undefined || dashboard?.status === "failed")}>
                <div className="min-h-[500px] flex justify-center items-center">
                    <div className="max-w-lg py-14">
                        <div className="h-48 flex">
                            <img src={sittingOnBench} alt="empty" className="max-w-full max-h-full m-auto object-contain" />
                        </div>

                        <div className="text-center mt-8">
                            <div className="font-semibold text-lg">
                                Sorry, you do not have a wallet yet.
                            </div>
                            <div className="text-fade mt-0.5">
                                Please click the button below to create your wallet in few seconds.
                            </div>
                            <div className="mt-8 flex justify-center">
                                <ButtonLoader type="button" loading={walletLoading} className="btn btn-ep-primary" onClick={createWallet}>
                                    Create Wallet
                                </ButtonLoader>
                            </div>
                        </div>
                    </div>
                </div>
            </Maybe>


        </div>
    )
}




const TransactionInfo = (props) => {
    return (
        <div className="transfer-beneficiary-list">
            {props.data.map((details, index) => 
                <div key={index} className="space-y-4">
                    
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Product
                        </div>
                        <div className="font-medium text-right">
                            {details.network?.label || "-"}
                        </div>
                    </div>
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Meter Number
                        </div>
                        <div className="font-medium text-right">
                            {details.account || "-"}
                        </div>
                    </div>
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Meter Type
                        </div>
                        <div className="font-medium text-right capitalize">
                            {details.accountType || "-"}
                        </div>
                    </div>
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Amount
                        </div>
                        <div className="font-medium text-right">
                            {details.amount === "" ? "-" : CurrencyFormat(details.amount) || "-"}
                        </div>
                    </div>
                    <Maybe condition={Object.keys(details?.employee).length > 0}>
                        <div className="flex space-x-4 justify-between">
                            <div className="text-fade">
                                Employee
                            </div>
                            <div className="font-medium text-right capitalize">
                                {details?.employee?.fullName ? details?.employee?.fullName : details?.employee?.firstName + " " + details?.employee?.lastName}
                            </div>
                        </div>
                    </Maybe>
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Phone Number
                        </div>
                        <div className="font-medium text-right">
                            {details.phoneNumber || "-"}
                        </div>
                    </div>
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Customer Name
                        </div>
                        <div className="font-medium text-right">
                            {details.name || "-"}
                        </div>
                    </div>
                    <div className="flex space-x-4 justify-between">
                        <div className="text-fade">
                            Customer Address
                        </div>
                        <div className="font-medium text-right">
                            {details.address || "-"}
                        </div>
                    </div>

                    <Maybe condition={props.type === "multiple"}>
                        <div className="flex justify-end">
                            <div onClick={() => props.removeForm(index)} className="w-max flex items-center text-red-400 hover:underline cursor-pointer">
                                <FontAwesomeIcon icon="trash" className="mr-1" />
                                Remove
                            </div>
                        </div>
                    </Maybe>
                </div>
            )}
        </div>
    )
}



const SubmitButtons = (props) => {

    const checkDisabled = () => {
        // if (props.form.name !== "" && props.form.address !== ""){
        if (props.form.isValidated === true){
            return false;
        }
        return true;
    }

    return (
        <>
            <Maybe condition={props.type === "single"}>
                <Maybe condition={checkDisabled() === false}>
                    <ButtonLoader type="submit" loading={false} className="btn btn-ep-primary">
                        Make Payment
                    </ButtonLoader>
                </Maybe>
                <Maybe condition={checkDisabled() === true}>
                    <ButtonLoader type="button" loading={false} disabled={true} className="btn btn-ep-primary">
                        Make Payment
                    </ButtonLoader>
                </Maybe>
                <Link to="/payments/bills" className="btn btn-transparent-primary">
                    Cancel
                </Link>
            </Maybe>
            
            <Maybe condition={props.type === "multiple"}>
                <Maybe condition={checkDisabled() === false}>
                    <button type="submit" className="btn btn-ep-primary">
                        Add Another
                    </button>
                </Maybe>
                <Maybe condition={checkDisabled() === true}>
                    <button type="submit" disabled={true} className="btn btn-ep-primary">
                        Add Another
                    </button>
                </Maybe>
                <ButtonLoader type="button" loading={false} onClick={props.submitMultipleTransfer} className="btn btn-transparent-primary">
                    Proceed
                </ButtonLoader>
            </Maybe>

            <Maybe condition={props.type === "bulk-upload"}>
                <Maybe condition={props.bulkUpload !== null}>
                    {/* 
                    <button type="submit" className="btn btn-ep-primary">
                        Go to Preview
                    </button>
                     */}
                    <button type="submit" disabled={() => checkDisabled()} className="btn btn-ep-primary">
                        Make Payment
                    </button>
                    <ButtonLoader type="button" onClick={props.bulkUploadCancel} className="btn btn-transparent-primary">
                        Cancel
                    </ButtonLoader>
                </Maybe>
            </Maybe>
        </>
    )
}



export default BuyPower;